var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7BAD\u5934") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coinbase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BBE\\u7F6E\\u5F39\\u7A97",
    transform: "translate(-654.000000, -454.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(32.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7BAD\\u5934",
    transform: "translate(622.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4444444,16 L9.6,31.6444444 C9.15555556,32 8.35555556,32.0888889 8,31.7333333 C7.73333334,31.4666667 7.55555556,30.8444445 8.08888888,30.3111111 L21.8666667,16.0888889 L8.08888888,1.77777778 C8.08888888,1.77777778 7.55555556,0.888888875 8.26666666,0.444444438 C8.88888888,1.33226763e-15 9.33333331,0.177777781 9.6,0.444444438 L24.4444444,16 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#353F52"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuArrow);
export default __webpack_public_path__ + "static/media/icon_menu_arrow.a7d4646851dae610e66ef40236564181.svg";
export { ForwardRef as ReactComponent };